import { formatLogin, validateEmail } from './index';
export var getLoginValidator = function getLoginValidator(_ref) {
  var dictionary = _ref.dictionary,
      tooltipSetter = _ref.tooltipSetter;
  return function (value) {
    var _formatLogin = formatLogin(value),
        nonFormatted = _formatLogin.nonFormattedLogin,
        type = _formatLogin.type;

    if (!value) {
      tooltipSetter(dictionary.t('com.validation.required'));
      return false;
    }

    if (type !== 'email' && nonFormatted.length < 9) {
      tooltipSetter(dictionary.t('com.validation.minlength9'));
      return false;
    }

    if (type === 'email' && !validateEmail(nonFormatted)) {
      tooltipSetter(dictionary.t('com.validation.email.invalid'));
      return false;
    }

    tooltipSetter('');
    return true;
  };
};